(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-category-games-standalone/assets/javascripts/page-category-games-standalone.js') >= 0) return;  svs.modules.push('/components/casino-react/page-category-games-standalone/assets/javascripts/page-category-games-standalone.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect;
const ErrorPage = svs.components.casino_react.page_error;
const GridDisplayModes = svs.components.casino_react.common.constants.GridDisplayModes;
const CasinoSection = svs.components.casino_react.casinoSection.CasinoSection;
const setMetaTags = svs.components.lbUtils.setMetaTags.setMetaTags;
const SubHeader = svs.components.casino_react.sub_header.SubHeader;
const useSearchResults = svs.components.casino_react.casinoStore.hooks.useSearchResults;
const _svs$components$casin = svs.components.casino_react.hooks,
  useSetSearchParams = _svs$components$casin.useSetSearchParams,
  useSearchParams = _svs$components$casin.useSearchParams;
const FilterAndSort = svs.components.casino_react.filterAndSort.FilterAndSort;
const actionButtons = () => React.createElement(FilterAndSort, null);
const PageCategoryGamesStandalone = _ref => {
  let currentCategory = _ref.currentCategory,
    renderSubHeader = _ref.renderSubHeader;
  const _useSetSearchParams = useSetSearchParams(),
    setListIds = _useSetSearchParams.setListIds;
  const _useSearchParams = useSearchParams(),
    listIds = _useSearchParams.listIds;
  useEffect(() => {
    if (currentCategory.contentList && listIds.length === 0) {
      setListIds([currentCategory.contentList]);
    }
  }, [currentCategory.contentList, listIds, setListIds]);
  const _useSearchResults = useSearchResults(),
    games = _useSearchResults.games,
    error = _useSearchResults.error,
    isLoading = _useSearchResults.isLoading,
    totalGamesCount = _useSearchResults.totalGamesCount,
    fetchMore = _useSearchResults.fetchMore;
  useEffect(() => {
    setMetaTags({
      docTitle: currentCategory.metaTitle,
      metaDesc: currentCategory.metaDescription
    });
  }, [currentCategory.metaTitle, currentCategory.metaDescription]);
  if (error) {
    return React.createElement(ErrorPage, null);
  }
  return React.createElement(React.Fragment, null, renderSubHeader && React.createElement(SubHeader, {
    title: currentCategory.name
  }), React.createElement(CasinoSection, {
    ActionButtons: actionButtons,
    displayMode: GridDisplayModes.GRID_UNRESTRICTED,
    fetchMore: fetchMore,
    isLoading: isLoading,
    isSearchResult: (games === null || games === void 0 ? void 0 : games.length) === 0,
    items: games ? games : [],
    title: totalGamesCount ? "".concat(totalGamesCount, " spel") : '',
    totalGamesCount: totalGamesCount
  }));
};
setGlobal('svs.components.casino_react.pageCategoryGamesStandalone.PageCategoryGamesStandalone', PageCategoryGamesStandalone);

 })(window);